import { render } from "./UserAvatarList.vue?vue&type=template&id=8d28fb58&scoped=true"
import script from "./UserAvatarList.vue?vue&type=script&lang=js"
export * from "./UserAvatarList.vue?vue&type=script&lang=js"

import "./UserAvatarList.vue?vue&type=style&index=0&id=8d28fb58&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d28fb58"]])

export default __exports__